module.exports = __webpack_public_path__ + "img/table_en.69e09a18.jpg";